package com.gsb.vyapar.bhagya.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import gsb_vyparbhagya.composeapp.generated.resources.Res
import gsb_vyparbhagya.composeapp.generated.resources.*
import org.jetbrains.compose.resources.Font

@Composable
fun interRegular() = FontFamily(Font(Res.font.inter_regular))
@Composable
fun interSemiBold() = FontFamily(Font(Res.font.inter_semibold))
@Composable
fun interMedium() = FontFamily(Font(Res.font.inter_medium))
@Composable
fun interLight() = FontFamily(Font(Res.font.inter_light))
@Composable
fun interBold() = FontFamily(Font(Res.font.inter_bold))
@Composable
fun interItalic() = FontFamily(Font(Res.font.playfair_display_italic))